import { render } from "./ModifierSet.vue?vue&type=template&id=caf740b6&scoped=true"
import script from "./ModifierSet.vue?vue&type=script&lang=js"
export * from "./ModifierSet.vue?vue&type=script&lang=js"

import "./ModifierSet.vue?vue&type=style&index=0&id=caf740b6&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf740b6"]])

export default __exports__